/** Six segments, one per evidence link, in the record's header - P15 item 2.
 *
 * Filled is met, hollow is unmet (and its reason is the segment's title), dashed is not checked, grey
 * with a dash is not applicable (and its explanation is the title). **Never a single percentage**:
 * `screens/evidenceMeter.ts` decides each segment from the server's assessment and nothing adds them.
 * Every segment is a button that hands its link to `onOpen`, which opens the part of the receipt that
 * explains it. A shape and a word, never colour alone: each state has its own fill and its own
 * hidden word, and the reason is in the accessible name as well as in the title.
 */

import { STATE_WORD } from "../../screens/evidenceMeter";
import type { MeterLink } from "../../screens/evidenceMeter";
import styles from "./EvidenceMeter.module.css";

export function EvidenceMeter({
  links,
  onOpen,
  label = "Evidence chain",
}: {
  links: readonly MeterLink[];
  onOpen: (link: MeterLink) => void;
  label?: string;
}) {
  return (
    <ol className={styles.meter} aria-label={label} data-testid="evidence-meter">
      {links.map((link) => {
        const word = STATE_WORD[link.state];
        const name = link.reason
          ? `${link.label}: ${word}. ${link.reason}`
          : `${link.label}: ${word}.`;
        return (
          <li key={link.step} className={styles.item}>
            <button
              type="button"
              className={styles.segment}
              data-state={link.state}
              data-step={link.step}
              data-testid={`evidence-segment-${link.step}`}
              title={link.reason || `${link.label}: ${word}`}
              aria-label={name}
              onClick={() => onOpen(link)}
            >
              <span className={styles.bar} aria-hidden="true" />
              <span className={styles.word}>{link.label}</span>
              <span className="visuallyHidden">{word}</span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
